import { Button, HStack, Heading, Stack } from '@chakra-ui/react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { DashboardSectionRow } from '$/pages/DashboardPages/components/DashboardSectionRow';
import { ProjectGridItems } from '$/pages/DashboardPages/pages/Projects/components/ProjectGridItems';
import { type ProjectFolder } from '$/services/usecases/projects/mapper/editorProject';
import { type ProjectOverviewItem } from '$/services/usecases/projects/mapper/projectOverview';

interface Props {
  projects: ProjectOverviewItem[];
  folder: ProjectFolder;
  setSelectedFolderId: (folderId: string | null) => void;
}

export const ProjectFolderView: FC<Props> = ({
  folder,
  projects,
  setSelectedFolderId,
}) => {
  const { t } = useTranslation();
  return (
    <Stack gap='6' overflowY='auto' w='full' p='7'>
      <HStack>
        <Button
          px='0'
          leftIcon={<Icon icon='arrow_right' transform='rotate(180deg)' />}
          onClick={() => setSelectedFolderId(null)}
          variant='text'
        >
          {t('general.backToOverview')}
        </Button>
      </HStack>
      <Heading as='h1' mt='2' mb='4' fontSize='3xl'>
        {folder.name}
      </Heading>
      <DashboardSectionRow>
        <ProjectGridItems items={projects} hideNewProjectButton={true} />
      </DashboardSectionRow>
    </Stack>
  );
};
